import { Tooltip } from "antd";
import _ from "lodash";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { ACTION_BTN_HOVER_CLR, SELECT_EXPORT_PAGES } from "@/Constants/common";
import {
  deSelectAllCandidate,
  fetchAppliedCandidates,
  fetchAppliedShifts,
  setAppliedCandidatesLoading,
  updatePagination,
  updateCandidateStatus,
} from "@/reducers/client_candidates/candidatesapplied";
import { fetchCandidateTypes } from "@/reducers/clientdashboard";
import {
  _approveCandidate,
  _rejectCandidate,
} from "@/services/clientcandidates";
import { TOOLTIPTEXT, toastMessageText } from "@/utilities/CommonText";
import {
  handleAPICatch,
  showCommonToast,
  showSuccessToast,
  showWarningToast,
} from "@/utilities/utils";

import { _exportAppliedCandidates } from "../../../../../../services/clientexport";
import ExportButton from "../../../ActionButtons/ExportButton";
import ActionIcons from "../../../ActionIcons";

/**
 * This is a functional component that renders a set of actions for handling candidate applications. It includes functions to shortlist candidates, mark candidates as unsuitable, approve or reject candidates, and get contract IDs. It also renders the corresponding UI elements for these actions.
 *
 * @return {JSX.Element} The set of action buttons and their corresponding functionality.
 */
export const Actions = () => {
  const dispatch = useDispatch();
  const {
    selectedCandidate,
    appliedCandidates,
    selectContractId,
    selectedApplication,
    pagination,
    isSelectedAll,
  } = useSelector((state) => state.clientCandidatesApplied);
  const { isPremiumAccount, clientUserAllPermissions } = useSelector(
    (state) => state.session,
  );
  const { user } = useSelector((state) => state.clientProfile);
  const [shortListLoading, setShortListLoading] = useState(false);
  const [unsuitableLoading, setUnsuitableLoading] = useState(false);
  const [removeStatusLoading, setRemoveStatusLoading] = useState(false);
  const [approveLoading, setApproveLoading] = useState(false);
  const [rejectLoading, setRejectLoading] = useState(false);
  const [appliedCalender, setAppliedCalender] = useState(false);
  const [updateData, setUpdateData] = useState(false);

  /**
   * Function to handle reloading the table.
   *
   * @return {void}
   */
  const handleReloadTable = (
    unsuitable,
    sortlisted,
    isSelectedAll,
    ignoreIds,
    ids,
  ) => {
    dispatch(
      updateCandidateStatus({
        unsuitable,
        sortlisted,
        isSelectedAll,
        ignoreIds,
        ids,
      }),
    );
    dispatch(deSelectAllCandidate());
  };

  const refreshTable = () => {
    dispatch(
      updatePagination({
        ...pagination,
        currentPage: 1,
        isLastPage: false,
      }),
    );
    dispatch(setAppliedCandidatesLoading(true));
    dispatch(fetchAppliedCandidates());
  };

  /**
   * A function to approve or reject a candidate.
   *
   * @param {Object} data - the data of the candidate to be approved or rejected
   * @return {void}
   */
  const approveRejectCandidate = (data) => {
    const _handleFunc =
      data.status === "approve" ? _approveCandidate : _rejectCandidate;
    const response = _handleFunc(data);
    response
      .then((res) => {
        const {
          data: { data, message },
        } = res;
        // console.log(data)
        showSuccessToast(message);
        refreshTable();
        dispatch(fetchCandidateTypes());
      })
      .catch((error) => {
        handleAPICatch(error);
      })
      .finally(() => {
        setApproveLoading(false);
        setRejectLoading(false);
      });
  };

  /**
   * Get an array of contract IDs for selected applicants.
   *
   * @return {Array} Array of contract IDs
   */
  const getContractIDS = () => {
    let ids = [];
    appliedCandidates.map((candidate) => {
      if (_.includes(selectedApplication, candidate.applicant_id)) {
        ids.push(candidate.contract_id);
      }
    });
    return ids;
  };

  return (
    <div className="Actions_Wrapper tour-applied-actions">
      <div className="flex h-[40px] cursor-pointer overflow-hidden rounded-lg bg-grey [&>*:last-child]:border-r-0 [&>*]:grid [&>*]:w-[56px] [&>*]:min-w-[56px] [&>*]:place-items-center [&>*]:border-0 [&>*]:border-r [&>*]:border-r-[#E5E6E9] [&>*]:text-txtColor">
        {/* <MarkAsPreferredButton
          selectedCandidate={selectedCandidate}
          loading={shortListLoading}
          setLoading={setShortListLoading}
          deSelectAllCandidate={deSelectAllCandidate}
          page={SELECT_EXPORT_PAGES.APPLIED}
          isSelectedAll={isSelectedAll}
          ignoreIds={isSelectedAll
            ? appliedCandidates
              .filter(
                (ele) =>
                  !selectedApplication.includes(ele.applicant_id),
              )
              .map((ele) => ele.candidate_id)
              .join(",")
            : ""}
          callback={handleReloadTable}
          emptyMarkAsPreferredMessage={
            toastMessageText.noCandidateSelected
          }
        />
        <RemoveStatusButton
          selectedCandidate={selectedCandidate}
          loading={removeStatusLoading}
          setLoading={setRemoveStatusLoading}
          deSelectAllCandidate={deSelectAllCandidate}
          page={SELECT_EXPORT_PAGES.APPLIED}
          isSelectedAll={isSelectedAll}
          ignoreIds={isSelectedAll
            ? appliedCandidates
              .filter(
                (ele) =>
                  !selectedApplication.includes(ele.applicant_id),
              )
              .map((ele) => ele.candidate_id)
              .join(",")
            : ""}
          callback={handleReloadTable}
        />
        <MarkAsUnsuitableButton
          selectedCandidate={selectedCandidate}
          loading={unsuitableLoading}
          setLoading={setUnsuitableLoading}
          deSelectAllCandidate={deSelectAllCandidate}
          page={SELECT_EXPORT_PAGES.APPLIED}
          isSelectedAll={isSelectedAll}
          ignoreIds={isSelectedAll
            ? appliedCandidates
              .filter(
                (ele) =>
                  !selectedApplication.includes(ele.applicant_id),
              )
              .map((ele) => ele.candidate_id)
              .join(",")
            : ""}
          callback={handleReloadTable}
        /> */}

        {/* <PublishToAppLocum
          selectedContracts={selectContractId}
          listingData={appliedCandidates}
          isSelectedAll={isSelectedAll}
          handleReloadTable={refreshTable}
          selectedApplication={selectedApplication}
          pageType="applied"
        /> */}

        {/* <ChangeDurationOfNotSetBankContract
          selectedContracts={selectContractId}
          listingData={appliedCandidates}
          pageType="applied"
        /> */}

        {isPremiumAccount && (
          <Tooltip title={TOOLTIPTEXT.viewAppliedCalender}>
            <button
              className={`group focus:outline-none ${ACTION_BTN_HOVER_CLR.lightBlue}`}
              onClick={() => {
                if (isSelectedAll) {
                  showWarningToast(toastMessageText.cannotApproveAllCandidate);
                  return;
                }
                if (selectedApplication.length === 1) {
                  dispatch(
                    fetchAppliedShifts({
                      applicant_id: selectedApplication,
                      contract_id: parseInt(selectContractId[0]),
                      candidate_id: parseInt(selectedCandidate[0]),
                      forCalendar: true,
                      loading: appliedCalender,
                      setLoading: setAppliedCalender,
                    }),
                  );
                } else {
                  showCommonToast(toastMessageText.onlyOneCandidateSelected, {
                    id: "no-candidate-selected",
                  });
                }
              }}
            >
              <ActionIcons
                isLoading={appliedCalender}
                type={"appliedCalender"}
              />
            </button>
          </Tooltip>
        )}

        <ExportButton
          page={SELECT_EXPORT_PAGES.APPLIED}
          // exportUrl={routingConstants.exportApplied}
          exportFunction={_exportAppliedCandidates}
          selectedTablesData={selectedCandidate}
          ignoreIds={
            isSelectedAll
              ? appliedCandidates
                  .filter(
                    (ele) => !selectedApplication.includes(ele.applicant_id),
                  )
                  .map((ele) => ele.applicant_id)
                  .join(",")
              : ""
          }
          isSelectedAll={isSelectedAll}
          extraObj={{
            applicant_ids: selectedApplication.join(","),
          }}
          emptyExportMessage={toastMessageText.emptyExportMessageForCandidate}
        />
      </div>
    </div>
  );
};
